import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { GuestsPanel } from "../components/admin/GuestsPanel";
import { PhotosPanel } from "../components/admin/PhotosPanel";
import { AccountPanel } from "../components/admin/AccountPanel";

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);
  const [tab, setTab] = useState("guests");

  useEffect(() => {
    api
      .get("/auth/me")
      .then(() => setReady(true))
      .catch(() => navigate("/admin"));
  }, [navigate]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    navigate("/admin");
  };

  if (!ready) {
    return (
      <div className="min-h-screen bg-sand flex items-center justify-center">
        <p className="font-serif italic text-clay text-xl">Cargando…</p>
      </div>
    );
  }

  const tabBtn = (key, label, testid) => (
    <button
      data-testid={testid}
      onClick={() => setTab(key)}
      className={`rounded-full px-6 py-3 text-[11px] uppercase tracking-[0.25em] transition-colors ${
        tab === key ? "bg-clay text-cream" : "text-stone hover:text-clay"
      }`}
    >
      {label}
    </button>
  );

  return (
    <div data-testid="admin-dashboard" className="min-h-screen bg-sand">
      <header className="bg-cream border-b border-clay/10">
        <div className="max-w-6xl mx-auto flex items-center justify-between px-6 py-5">
          <div>
            <p className="font-script text-3xl text-clay leading-none">Emma & Jhonny</p>
            <p className="mt-1 text-[10px] uppercase tracking-[0.3em] text-stone">Panel de administración</p>
          </div>
          <button
            data-testid="admin-logout-button"
            onClick={logout}
            className="rounded-full border border-clay/30 text-clay px-6 py-3 text-[11px] uppercase tracking-[0.25em] hover:bg-clay hover:text-cream transition-colors"
          >
            Salir
          </button>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-6 py-10">
        <div className="flex gap-2 mb-10">
          {tabBtn("guests", "Invitados y RSVP", "tab-guests")}
          {tabBtn("photos", "Fotos de la Boda", "tab-photos")}
          {tabBtn("account", "Cuenta", "tab-account")}
        </div>
        {tab === "guests" ? <GuestsPanel /> : tab === "photos" ? <PhotosPanel /> : <AccountPanel />}
      </main>
    </div>
  );
}
